import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const OrgLogout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        localStorage.clear();
        sessionStorage.clear();
        navigate('/org/login?redirect=/org/account');
    }, [navigate]);

    return null;
};

export default OrgLogout;
